module.exports = __webpack_public_path__ + "img/product_81.f7857e8.webp";